module.exports = __webpack_public_path__ + "static/media/loginBackgroundImg.e8783244.jpeg";